import React from 'react';
import { Popconfirm } from 'antd';
import CustomButton from '../CustomButton';

export function ModificationModuleInnerSaveButton({ onClick, loading }) {
  return (
    <Popconfirm
      placement="topLeft"
      title="¿Está seguro(a) de guardar los ajustes realizados?"
      okText="Sí"
      cancelText="No"
      onConfirm={onClick}
    >
      <CustomButton
        htmlType="button"
        loading={loading}
        text="Guardar Modificación"
      />
    </Popconfirm>
  );
}

export default function ModificationModuleSaveButton({
  onConfirm,
  title = (
    <>
      <p>
        Esta Modificación puede implicar cambiar / ajustar otro(s) Módulos de la
        pantalla anterior.
      </p>
      <p>
        Por favor verifique con atención y seleccionelo(s) para ajustarlo(s) en
        caso de ser requerido.
      </p>
    </>
  ),
  loading,
}) {
  return (
    <Popconfirm
      placement="topLeft"
      title={title}
      okText="Entendido"
      cancelText="Cancelar"
      onConfirm={onConfirm}
    >
      <ModificationModuleInnerSaveButton loading={loading} />
    </Popconfirm>
  );
}
